var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCircleAge = function SvgCircleAge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#circle_age_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 24C48 10.745 37.255 0 24 0S0 10.745 0 24s10.745 24 24 24 24-10.745 24-24Z",
    fill: "#E3C0F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.943 38.001H15.055a3.181 3.181 0 0 1-3.172-3.172v-1.4c0-3.423 1.438-6.688 3.97-8.99a3.154 3.154 0 0 1 3.823-.317c1.252.803 2.745 1.23 4.326 1.23 1.58 0 3.073-.427 4.325-1.23a3.154 3.154 0 0 1 3.823.317 12.127 12.127 0 0 1 3.97 8.99v1.4a3.179 3.179 0 0 1-3.177 3.172ZM17.97 24.712a2.05 2.05 0 0 0-1.384.536 11.067 11.067 0 0 0-3.615 8.181v1.4a2.084 2.084 0 0 0 2.078 2.078h17.889c1.148 0 2.078-.93 2.078-2.078v-1.4c0-3.111-1.313-6.081-3.615-8.181a2.059 2.059 0 0 0-2.494-.208c-1.427.919-3.128 1.406-4.916 1.406-1.789 0-3.49-.487-4.917-1.406a2.012 2.012 0 0 0-1.105-.328Z",
    fill: "#7301B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 24.11a7.065 7.065 0 0 1-7.055-7.055A7.061 7.061 0 0 1 24 10a7.065 7.065 0 0 1 7.055 7.055c-.006 3.888-3.167 7.054-7.055 7.054Zm0-13.01a5.96 5.96 0 1 0 0 11.921 5.96 5.96 0 0 0 0-11.922Z",
    fill: "#7301B9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "circle_age_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
};
export default SvgCircleAge;